const i18n = {
    lang: "zh_cn",
    copyright1: "版权所有@2007-",
    copyright2: " 大易云计算有限公司",
    systemName: "智能视频面试系统",
    pageTitle: {
        index: "首页",
        check: "设备检测",
        record: "正式录制",
        tryRecord: "试录",
        feedback: "意见反馈"
    },
    result: {
        title: "单向视频面试结果",
        interviewTitle: "面试信息",
        recordStatus: "录制状态",
        recordComplete: "已完成",
        submitStatus: "提交情况",
        finishTime: "交卷时间",
        finishTimes: "提交时间",
        totalFileDuration: "视频总时长",
        startTime: "开始时间",
        endTime: "结束时间",
        postName: "应聘职位",
        paperName: "面试试卷",
        questionNum: "题目数",
        videoResource: "视频来源",
        fileStatus: "视频文件状态",
        fileExist: "存在",
        fileNotExist: "不存在",
        videoTitle: "问题及播放视频",
        recordNotFinish: "视频面试尚未完成，请完成后再查看",
        moreBtnText: "查看简介",
        videoTime: '视频时间',
        total: '共{num}题',
        summaryTitle: '视频分析结论概述',
        summaryInfo: '情绪占比',
        summaryDetailTitle: '视频分析详情',
        emotionInfo: '每题情绪',
        analysisInfo: '每题分析',
        personalityInfo: '个性特征描述',
        characteristicsInfo: '适合${type}型人的岗位特质',
        occupationInfo: '${type}型人适合的职业',
        realTimeInfo: '视频实时分析',
        upText: '展开',
        downText: '收起',
        lastQue: '上一题',
        nextQue: '下一题',
        expressText1: '有用',
        expressText2: '没用'
    },
    check: {
        title: "智能视频面试设备检测",
        subtitle: "请检测并确认您面试过程中使用的设备和网络都符合要求，如不符合要求请根据提示尽快更换",
        browser: "浏览器",
        browserInfo: "支持谷歌58+版本，火狐56+版本和Safari 11+版本。如未通过，请安装要求版本浏览器",
        network: "网络检测",
        networkInfo: "请保持100Kbps的及以上。如未通过，请检测网络情况",
        microphone: "麦克风",
        microphoneInfo: "请保证麦克风正常使用。如未通过，请检测麦克风设置",
        camera: "摄像头",
        cameraInfo: "请保证摄像头正常使用。如未通过，请检测测摄像头设置",
        pendingStatus: "检测中",
        passedStatus: "已通过",
        failedStatus: "未通过",
        btnText: "进入录制"
    },
    startInterviewModal: {
        title: "进入面试",
        content1: "如未参加过智能视频面试，",
        content2: "请先选择试录一次进行面试体验。",
        cancelText: "试录一次",
        okText: "正式录制"
    },
    privacyModal: {
        detailBtnText: "您可以查看完整版隐私政策",
        okText: "同意并继续",
        cancelText: "不同意"
    },
    index: {
        title: "您好，",
        titleTips: "（若非本人请立即退出小程序）",
        titlePCTips: "（若非本人请立即退出）",
        subtitle1: "欢迎进入",
        subtitle2: "视频面试系统",
        subtitlePC1: "欢迎来到",
        subtitlePC2: "智能视频面试，您面试的职位是：",
        positionText: "您即将面试的职位是",
        tryVideoBtnText: "试录一次",
        recordBtnText: "立即开始录制",
        instructionsText1: "我已阅读",
        instructionsText2: "《视频面试录制须知》",
        instructionsTips: "请先阅读《视频面试录制须知》",
        checkBtnText: "检测录制设备",
        skipBtnText: "直接跳过",
        notSuportMobileText: "请前往微信扫码打开小程序",
        browserNotSuportText: "您使用的浏览器暂时不支持视频面试，请更换为新版的Chrome或者Safari浏览器进行视频面试！"    //，qq
    },
    noticeModal: {
        okText: "我知道了，开始录制"
    },
    ajustModal: {
        title1: "请调试摄像头至合适位置",
        title2: "露出五官",
        btnText: "调整画面完毕"
    },
    tryFinish: {
        title: "试录结束",
        subtitle1: "恭喜您完成试录。试录视频不保存，仅作流程体验之用。",
        subtitle2: "请点击下方按钮开始正式录制。注意：开始后尽量不要中断哦！",
        btnText: "进入正式录制"
    },
    question: {
        questionTitle: "本题剩余思考时间",
        questionSubtitle: "答题时间不超过",
        minute: "分钟",
        second: "秒",
        questionText: "题目",
        demo: "你更喜欢从事研发性质的工作还是实践性质的工作？"
    },
    record: {
        loadingText: "加载中",
        startText: "立刻开始录制",
        recordText: "本题倒计时",
        recordTextPC: "本题剩余时间",
        recordTextPC1: "倒计时",
        endText: "结束本题",
        endTextPC: "结束本题",
        timeLimitText: "录制时间需不少于10s",
        stopingText: "正在结束",
        recordFailText: "录制失败，请重录",
        poorVideoQuality: "检测到视频录制效果不佳，建议检测网络并重录",
        rerecordLimitText: "重录次数已用完，请提交。",
        replayLimitText: "回放次数已用完，请重录或提交。"
    },
    stopRecordModal: {
        title: "本题录制结束",
        playbackText: "回放",
        rerecordText: "重录",
        confirmTitle: "重新录制将会覆盖已录制的视频",
        confirmSubtitle: "是否重新录制",
        confirmRed: "剩余重录次数：",
        confirmBtnCancel: "取消"
    },
    replayModal: {
        title: "回放结束",
        playbackText: "回放",
        rerecordText: "重录",
        okText1: "提交",
        okText2: "提交，进入下一题",
        okText3: "提交，完成全部录制",
        autoText: "自动提交",
        replayFailText: "获取视频链接失败！"
    },
    replay: {
        btnText: "结束回放"
    },
    finish: {
        title: "提交视频成功",
        subtitle1: "恭喜您完成了",
        subtitle2: "的视频面试，",
        subtitle3: "请耐心等待HR的答复"
    },
    evaluate: {
        title: "本次面试体验",
        tag1: "体验好",
        tag2: "网络流畅",
        tag3: "方便快捷",
        placeholder: "如有意见和建议，请在此填写",
        btnText: "提交评价",
        successTitle: "提交评价成功",
        successSubtitle: "感谢您对本次面试体验的评价反馈。",
        exitText: "我知道了",
        scoreTitle: "体验评分",
        scoreText: "分",
        tagTitle: "体验印象",
        textareaTitle: "反馈意见"
    },
    globalStatus: {
        status1Text1: "面试尚未开始，请耐心等待",
        status1Text2: "面试时间",
        status2Text1: "面试已结束。",
        status2Text2: "如仍需视频面试，请联系HR。",
        status2Text3: "面试时间",
        status3Text1: "将继续上次的视频录制",
        status3Text2: "面试有效期内，",
        status3Text3: "中途退出后可再进入",
        status3Text4: "次。",
        status4Text1: "很遗憾，可再进入次数已用完",
        status4Text2: "如需继续视频面试，请及时联系HR。",
        status5Text1: "您已使用PC链接进行录制",
        status5Text2: "请点击PC链接继续操作。",
        status6Text1: "麦克风或摄像头权限未开启",
        status6Text2: "请去设置中允许访问。",
        status6Text3: "权限开启后，请退出小程序重新进入",
        status7Text1: "账号无效",
        status7Text2: "如仍需视频面试，请联系HR。",
        status8Text1: "您已使用小程序进行录制",
        status8Text2: "请扫小程序码继续操作。",
        status9Text1: "麦克风和摄像头权限未开启，请尝试以下方法：",
        status9Text2: "右上角菜单-设置-高级-内容设置-麦克风、摄像头-禁止-",
        status9Text21: ":443-右侧删除",
        status9Text3: "1.刷新页面，如出现授权提示框，请点击【允许】",
        status9Text4: "2.右上角菜单-选项-隐私与安全-权限-麦克风、摄像头-设置-",
        status9Text41: ":443-允许-保存更改",
        status9Text5: "2.左上角Safari-偏好设置-网站-麦克风、摄像头-申请/允许",
        statusBtnText1: "我知道了",
        statusBtnText2: "继续录制",
        statusBtnText3: "去设置",
    },
    device: {
        title: "此次视频面试已在其他设备上进行",
        subtitle1: "如已进行的面试非您本人操作，",
        subtitle2: "请及时联系HR。",
        btnText: "我知道了",
		kickOtherBtn: "我要在本设备作答",
    },
    lowVersion: {
        title: "当前微信版本不支持视频录制",
        subtitle: "请更新至微信最新版本后重新进入。",
        btnText: "我知道了"
    },
    network: {
        title: "网络异常",
        btnText: "重新加载"
    },
    tips: {
        title: "此小程序只用于视频面试。",
        subtitle: "抱歉，您尚未有此面试安排。",
        btnText: "我知道了"
    },
    showModal: {
        title: "提示",
        titlePC: "温馨提示"
    },
    globalError: {
        equipmentNotFound: "没有找到设备",
        browserNotSurport: "浏览器不支持获取获取摄像头和麦克风",
        unknowError: "未知错误",
        btnText: "我知道了"
    },
    report: {
        uploadSuccess: "上传视频成功！",
        uploadFail: "上传视频失败！",
        generateReport: "生成报告",
        download: "下载报告",
        viewReport: "查看报告",
        generate: "报告生成中...",
        originalVideo: "原视频",
        liveAnalysis: "AI实时分析",
        analysisReport: "分析报告",
        reportGenerate: "AI实时分析和分析报告生成中...",
        reportFail: "生成失败，请联系顾问",
        summary: "视频总分析",
        emotions: "情绪状态",
        characteristics: "性格特征",
        mapping: "大五人格",
        RIASECModel: "霍兰德职业兴趣",
        liveEmotions: "实时情绪",
        liveCharacteristics: "实时性格特征",
        angry: "愤怒",
        happines: "高兴",
        fear: "恐惧",
        disgust: "厌恶",
        contempt: "怀疑",
        neutral: "平和",
        surprise: "惊讶",
        sadness: "悲伤",
        honesty: "诚实度",
        confidence: "自信度",
        curiosity: "好奇",
        passion: "热情度",
        judging: "审视度",
        disagree: "不同意",
        nervousness: "紧张",
        angryInfo1: "一种紧张和敌意的感觉, 通常是由对自身, 自我的财产, 权利或价值观受到威胁而引起的焦虑。",
        angryInfo2: "研究人员表示, 愤怒的脸很好用, 因为每个面部表情都让人看起来更强壮。这张脸让威胁我们的人知道我们是认真的。这是人类最强大的情感之一, 它显示了人脸具有多强的表现力。这个面部表情是一个警告。无论是简单地恐吓还是向对方表明冲突已经开始。",
        happinesInfo1: "高兴是一种精神或情感的幸福状态, 可以由积极或愉快等情绪来定义, 包括满足感, 强烈的喜悦感。",
        happinesInfo2: "尽管有着友好的含义, 研究人员相信人类的笑容可能会有更邪恶的起源。许多灵长类动物为了维护自己的统治或显示其在社会结构中的地位会露出牙齿。一些研究人员认为, 这是非语言的标志, 最终演变成一个微笑。",
        fearInfo1: "不愉快的情绪状态, 包括对真实的外部威胁或危险产生的生理及心理反应。",
        fearInfo2: "每个以恐惧为基础的面部表情都为我们的“战斗或逃离现场”的反应作出准备。这种面部表情大大超出了我们生理的一般反应。张大眼睛以打开视野, 以汲取更多的光线, 看清我们周围的危险。同样的表情也在“身体供氧通道”上发生。张开鼻孔增加氧气摄入量, 以帮助我们备战或者逃离现场。",
        disgustInfo1: "对某一事物或人产生的反感情绪可以被视作为厌恶的, 讨厌的或令人不愉快的。",
        disgustInfo2: "厌恶的脸不只是表现出我们的厌恶, 它也有效地保护我们。皱鼻子使鼻道关闭, 保护我们免受例如危险烟雾地侵入, 眯眼的动作使我们的眼睛免受伤害。",
        contemptInfo1: "把某人或某物看作低劣的,基础的或毫无价值的感情或态度。",
        contemptInfo2: "尽管怀疑的情绪可以与愤怒和不信任重叠, 但面部表情是独一无二的。这是唯一的表情, 只发生在脸上的一面, 可以在强度上有所不同。最强的是, 一只眉毛可能会下降, 而下眼睑和唇角在同一侧上升。在最隐蔽的情况,嘴角可能只会短暂上升。",
        neutralInfo1: "一种心理稳定和镇静的状态，不被过往经历或外显的情绪、疼痛或其他可能使人失控的现象所干扰。",
        neutralInfo2: "然而，平和并不意味着个体没有情感——它涵盖了感觉体验范围的中间部分。在痛苦与愉悦之间，情感色调区域表现为相对平淡，既不明显痛苦也不明显愉快，没有主导情感。",
        surpriseInfo1: "动物和人类因意外事件而产生的惊讶反应。",
        surpriseInfo2: "虽然轻蔑的情绪可以与愤怒和不信任相重叠, 但面部表情却是独一无二的。这是唯一的可以只发生在一侧脸上的面部情绪表达, 并可以有不同的情绪强度。最有力的表达为, 一个眉毛可能会降低, 而下眼睑和嘴角在同一侧升起。最隐秘的表达为, 嘴角可能只是稍稍地抬起。",
        sadnessInfo1: "悲伤是一种与痛苦相关联的情绪, 具有处于劣势, 损失某物或某人, 绝望, 悲痛, 无助, 失望和悲哀的感觉。",
        sadnessInfo2: "研究人员表示, 悲伤是很难作假。其中一个可以看出是悲伤情绪的脸部迹象是眉毛内侧抬高,很少有人可以按要求做到。",
        honestyInfo1: "反映对真实性的追求, 而不是思想和行动上的欺骗。着重于个人在互动和反应中如实反应的条件。",
        honestyInfo2: "特征描述：待人直率, 避免欺骗他人。",
        confidenceInfo1: "衡量受试者对自己的价值和能力的看法, 以及他/她对自己的信心。它衡量的是主体对自己的积极结果的信心程度, 而不是消极的结果, 例如失败或其他人的意见。",
        confidenceInfo2: "特征描述：对成功的结果保持自我控制和个人信念；对自己和未来会有积极的态度。",
        curiosityInfo1: "衡量受试者对持续学习, 找出解决办法, 及对智力挑战的兴趣程度。它衡量他们探索周围世界的动机, 并获得新的知识和技能, 而不管这是否把他们带到了他们的舒适区之外。好奇也意味着能够质疑和挑战他人。",
        curiosityInfo2: "特征描述：广泛的知识焦点；对不寻常的人的行为和情感的着迷；对事物为什么与规范不同而感兴趣。",
        passionInfo1: "衡量受试者对主题的强烈情感, 热忱和投入精神。",
        passionInfo2: "特征描述：不安；在紧张的情况下挣扎着保持冷静；在某些情况下无法保持镇定。",
        nervousnessInfo1: "衡量受试者表现出的不安和焦虑的程度。",
        nervousnessInfo2: "特质描述：不安; 在压力下努力保持冷静; 在某些情况下无法保持冷静。",
        mappingObj: {
            headerText1: "大五人格维度",
            headerText2: "特征",
            headerText3: "情感",
            stressReaction: "神经质",
            outgoing: "外倾性",
            creativity: "开放性",
            agreeableness: "宜人性",
            conscientiousness: "责任心",
            extravesion: "外向",
            selfConfidense: "自信",
            innovation: "革新",
            empathy: "同情",
            disagreeing: "不同意",
            trust: "信任",
            easyGoing: "随和"
        },
        riasecModel: {
            infoText1: "霍兰德RIASEC模型包括6个职业的主题：现实型, 研究型, 艺术型, 社会型, 企业型和传统型。大量的分析表明这六个主题维度和五大人格维度之间的30个关联度的平均效应的大小。在这30个相互关系中的其中5个似乎对男性女性都非常重要。",
            infoText2: "我们也可以在以下流行的工作角色中, 划分大五性格纬度与有效工作者的关联度：",
            low: "低",
            med: "中",
            high: "高",
            stressReactionText1: "业务管理; 销售代表; CEO; 警官; 金融",
            stressReactionText2: "商业顾问协调员; HR",
            stressReactionText3: "社会工作者; 客户代表; 飞行客舱乘员组",
            outgoingText1: "作家; 研究员; 记账员; 工程师; 实验室技术员; 文书工作者; 资料输入; 联系; 律师; 会计; IT",
            outgoingText2: "老师; 顾问接待员",
            outgoingText3: "销售代表; 商业领袖; 律师; 培训师; 酒店经理; 代理; 公共关系; 市场经理",
            creativityText1: "技术员; 文书工作者; 电工;管道工; 木匠; 数据录入员; 医生; IT支持/维修",
            creativityText2: "队长; 人力资源; 主持人",
            creativityText3: "顾问; 广告执行; 卫生保健; 工人; 作家; 艺术家; 设计师",
            agreeablenessText1: "政治家; 业主; 企业家; 警官; 律师; 司法",
            agreeablenessText2: "主持人; 谈判",
            agreeablenessText3: "照顾者; 讲师; 社会工作者",
            conscientiousnessText1: "管理支持; 服务员女服务员; 工厂员工; 邮政职员; 生成器; 维修工人",
            conscientiousnessText2: "队长; 高级业务经理",
            conscientiousnessText3: "监事; 客户服务/销售代表; 会计; 校对; 编辑; 统计员"
        },
        emotion: {
            surprise: '惊讶',
            happiness: '喜悦',
            neutral: '平静',
            sadness: '悲哀',
            disgust: '厌恶',
            anger: '愤怒',
            fear: '害怕',
            contemplation: '蔑视',
            attention: '注意力'
        },
        strong: '强',
        weak: '弱',
        summaryInfo1: 'AI视频面试分析显示，受测者的注意力得分为${num}，注意力${degree}',
        summaryInfo2: '职业性格：',
        summaryInfo3: '得分',
        summaryInfo4: '表达强度',
        summaryInfo5: '情绪',
        questionNum: '第 ${num} 题',
        questionTotal: '（ 共${num}题 ）'
    }
}

export default i18n;
